import { render, staticRenderFns } from "./BackofficeReserva.vue?vue&type=template&id=2601627c&scoped=true"
import script from "./BackofficeReserva.vue?vue&type=script&lang=ts"
export * from "./BackofficeReserva.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeReserva.vue?vue&type=style&index=0&id=2601627c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601627c",
  null
  
)

export default component.exports